import axios from 'axios'
import { ElMessage, ElMessageBox } from 'element-plus'

axios.defaults.headers['clientType'] = 'wxMini'
// Create axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 7200000  // 2小时
})

// Request interceptor
service.interceptors.request.use(
    config => {
        // Debug: Log the full request URL
        console.log('=== Request Debug ===');
        console.log('Full URL:', config.baseURL + config.url);
        console.log('Method:', config.method);
        console.log('Headers:', config.headers);
        
        // 登录/注册等接口传 isToken: false，不携带过期 token（避免网关鉴权干扰）
        const isToken = (config.headers || {}).isToken === false
        const token = localStorage.getItem('token')
        if (token && !isToken) {
            config.headers['Authorization'] = 'Bearer ' + token
            console.log('Auth header sent:', config.headers['Authorization']) // Debug line
        }

        // Get user information from localStorage and add to headers
        const userInfo = localStorage.getItem('userInfo')
        if (userInfo) {
            try {
                const user = JSON.parse(userInfo)
                console.log('User info from localStorage:', user) // Debug log
                
                // Add user information headers that HeaderInterceptor expects
                // The user object structure depends on the API response
                if (user.userId || user.id || user.user?.userId) {
                    const userId = user.userId || user.id || user.user?.userId
                    config.headers['user_id'] = userId.toString()
                    console.log('User ID header sent:', config.headers['user_id'])
                }
                if (user.userName || user.username || user.name || user.user?.userName) {
                    const userName = user.userName || user.username || user.name || user.user?.userName
                    config.headers['username'] = userName
                    console.log('Username header sent:', config.headers['username'])
                }
                if (user.userKey || user.key || user.user?.userKey) {
                    const userKey = user.userKey || user.key || user.user?.userKey
                    config.headers['user_key'] = userKey
                    console.log('User key header sent:', config.headers['user_key'])
                }
            } catch (error) {
                console.error('Error parsing user info from localStorage:', error)
            }
        }
        
        console.log('=== End Request Debug ===');
        return config
    },
    error => {
        console.log(error)
        return Promise.reject(error)
    }
)

// Response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data

        // If the custom code is not 200, it is judged as an error.
        if (res.code && res.code !== 200) {
            // Special handling for "no parking record found" - these are not errors
            if (res.msg && (res.msg.includes('未找到该车牌的停车记录') || 
                           res.msg.includes('未找到该车道的有效停车记录') ||
                           res.msg.includes('未找到该停车记录'))) {
                console.log('No parking record found (normal business scenario):', res.msg);
                // Return the response as-is without throwing error
                return res;
            }

            const skipErrorMessage = (response.config?.headers || {}).skipErrorMessage === true
            if (!skipErrorMessage) {
                ElMessage({
                    message: res.msg || 'Error',
                    type: 'error',
                    duration: 5 * 1000
                })
            }

            // 401: Unauthorized - token expired or invalid
            if (res.code === 401) {
                const skipRelogin = (response.config?.headers || {}).isToken === false
                if (!skipRelogin) {
                    ElMessageBox.confirm(
                        'You have been logged out, you can cancel to stay on this page, or log in again',
                        'Confirm logout',
                        {
                            confirmButtonText: 'Re-Login',
                            cancelButtonText: 'Cancel',
                            type: 'warning'
                        }
                    ).then(() => {
                        localStorage.removeItem('token')
                        location.reload()
                    })
                }
            }
            return Promise.reject(new Error(res.msg || 'Error'))
        } else {
            return res
        }
    },
    async error => {
        const config = error.config;

        // If the error is a timeout and we haven't retried yet
        if (error.message.includes('timeout') && !config._retry) {
            config._retry = true;
            ElMessage.warning('网络请求超时，正在重试...');

            try {
                // Retry the request
                return await service(config);
            } catch (retryError) {
                return Promise.reject(retryError);
            }
        }

        console.log('err' + error)
        ElMessage({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

// WebSocket functionality temporarily disabled
// The following code was removed to fix compilation errors:
// - getWebSocketUrl function
// - wsUrl variable
// - socket initialization
// 
// To re-enable WebSocket functionality in the future:
// 1. Configure WebSocket server in backend
// 2. Uncomment and implement WebSocket connection logic
// 3. Add proper error handling and reconnection logic

export default service
